import * as Sentry from "@sentry/react";

import { setReportErrorCallback } from "@companion-core/shared/app/Utils/errorReporting";

export const initSentry = () => {
  const { VITE_ENVIRONMENT, VITE_SENTRY_DSN, VITE_SENTRY_ORIGIN } = import.meta.env;
  const clientName = import.meta.env.VITE_CLIENT_NAME || "johnpaul";
  Sentry.init({
    environment: VITE_ENVIRONMENT,
    dsn: VITE_SENTRY_DSN,
    tracePropagationTargets: [new RegExp(VITE_SENTRY_ORIGIN || "localhost")],
    integrations: [
      Sentry.browserTracingIntegration({
        traceFetch: false,
        traceXHR: false,
      }),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  Sentry.setContext("companion_client", { name: `companion-react-${clientName}` });

  if (!VITE_SENTRY_DSN) return;

  setReportErrorCallback((error, details) => {
    Sentry.captureException(error, {
      tags: details?.tags,
      contexts: details?.contexts,
    });
  });
};
